module.exports = __webpack_public_path__ + "img/share_tw.58e12550.png";